import { SessionService } from './../../shared/service/session.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { SystemService } from '../system/system.service';


@Injectable({ providedIn: 'root' })
export class ErrorInterceptorService implements HttpInterceptor {
    constructor(
        private sessionService: SessionService,
        private systemService: SystemService,
        private router: Router
    ) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.error?.message.includes('x-device-info header is required')) {
                    return from(this.systemService.initializeDeviceId()).pipe(
                        switchMap((newDeviceId: string) => {
                            return next.handle(this.addDeviceIdHeader(request, newDeviceId));
                        })
                    );
                }

                if (error.status === 401) {
                    const isRefreshRequest = request.url.includes('/session/') && request.url.includes('/refresh');
                    const isSessionInvalidMessage = error.error?.message === 'Session is no valid anymore';

                    if (isSessionInvalidMessage && !isRefreshRequest) {
                        return this.sessionService.renew(request, next);
                    } else {
                        this.sessionService.logoutAndRedirect();
                        return throwError(() => error);
                    }

                } else if (error.status === 403 && !location.href.includes('/sign/in')) {
                    this.router.navigate(['/error'], { fragment: '403' });
                }

                return throwError(() => error);
            })
        );
    }

    private addDeviceIdHeader(request: HttpRequest<any>, deviceId: string): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                'x-device-info': deviceId
            }
        });
    }
}
